import LoadsBulkActionConfirmation from './loads-bulk-action-confirmation';

export default LoadsBulkActionConfirmation;
